import React, { useContext } from 'react';

import { Flex } from '@qality/common-components/src/atoms/Flex';
import { SpinnerLoader } from '@qality/common-components/src/molecules/SpinnerLoader';
import { Utils } from '@qality/common-utils';

import EmptyGadget from '../EmptyGadget';
import LastTestCycleDetails from './LastTestCycleDetails';
import { RecentTestCyclesContext } from './RecentTestCyclesProvider';
import RecentTestCyclesTable from './RecentTestCyclesTable';

export const RecentTestCyclesView: React.FC = () => {
  const { testCycles, isTableView, isLoading } = useContext(
    RecentTestCyclesContext
  );

  return (
    <>
      {isLoading && (
        <Flex justifyCenter paddingSize='medium'>
          <SpinnerLoader text='We are loading data...' />
        </Flex>
      )}
      {!isLoading &&
        (Utils.isNilOrEmpty(testCycles) ? (
          <EmptyGadget message='There are no Test Cycles yet' />
        ) : isTableView ? (
          <RecentTestCyclesTable />
        ) : (
          <LastTestCycleDetails />
        ))}
    </>
  );
};
